import { render, staticRenderFns } from "./Outstanding.vue?vue&type=template&id=459d2ec6&scoped=true&"
import script from "./Outstanding.vue?vue&type=script&lang=ts&"
export * from "./Outstanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d2ec6",
  null
  
)

export default component.exports